'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rules = exports.getStylizrInstance = exports.stylizrComposer = undefined;

var _composer = require('./composer');

var _composer2 = _interopRequireDefault(_composer);

var _getStylizrInstance = require('./getStylizrInstance');

var _getStylizrInstance2 = _interopRequireDefault(_getStylizrInstance);

var _rules = require('./rules');

var rules = _interopRequireWildcard(_rules);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.stylizrComposer = _composer2.default;
exports.getStylizrInstance = _getStylizrInstance2.default;
exports.rules = rules;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-stylizr/lib/cjs/index.js
 ** module id = 495
 ** module chunks = 1
 **/